<template>
  <div v-if="loading">
    <loading />
  </div>
  <div
    class="w-full grid grid-rows-1-auto border border-black -mb-px"
    :class="{
      'border-red-500 text-red-500': upcoming && !failed && !unstarted,
      'border-gray-500 text-gray-500': invitation || finished || unstarted,
      'border-red-900 text-red-900': failed,
    }"
    @click="openTargetDetails()"
    v-else
  >
    <div class="grid grid-cols-auto-1 gap-3 p-3 cursor-pointer">
      <div :class="{'text-green-500': finished}">
        <icon
          :name="finished ? 'Check' : target.group ? 'Contacts' : 'Target'"
          size="1.3rem"
          :settings="{circle: finished}"
        />
      </div>
      <div>
        <div class="grid grid-cols-1-auto">
          <h3>{{ activity.title }}</h3>
          <div v-if="invitation">
            <wd-button class="text-red-500" @input="rejectRequest" transparent>
              <span>
                <icon name="Reject" size="1.3rem" />
              </span>
            </wd-button>
            <wd-button class="ml-2 text-green-500" @input="acceptRequest" transparent>
              <span>
                <icon name="Accept" size="1.3rem" />
              </span>
            </wd-button>
          </div>
        </div>
        <div class="text-sm grid grid-cols-1-auto">
          <div class="ml-auto italic" v-if="finished">{{ $t('general.finished') }}</div>
          <div class="ml-auto italic" v-else-if="failed">{{ $t('targets.failed') }}</div>
          <div v-else>
            <span v-if="unstarted">{{ target.target }}x</span>
            <span v-else>{{ target.value }}/{{ target.target }}</span>
          </div>
          <div v-if="unstarted">{{ $t('targets.starts') }} {{ timeUntil(target.start) }}</div>
          <div v-else-if="!invitation && !finished && !failed">
            Noch {{ daysUntil(target.end) }} Tag{{
            daysUntil(target.end) !== 1 ? "e" : ""
            }}
          </div>
          <div v-else-if="user">{{ user.username }}</div>
        </div>
      </div>
    </div>
    <div v-if="!invitation && !finished && !failed && !unstarted">
      <progress-bar :amount="percentage" :css="upcoming ? 'bg-red-500' : 'bg-black'" />
    </div>
  </div>
</template>

<script>
const ProgressBar = require("@/modules/core/components/ProgressBar.vue")
  .default;
import DateMixin from "@/mixins/DateMixin";

import { Target } from "@/modules/targets/viewmodels/Target";
import { ActivityModel } from "@/modules/activities/viewmodels/Activity";

export default {
  name: "Target",
  mixins: [DateMixin],
  data() {
    return {
      user: null
    };
  },
  props: {
    target: {
      type: Target
    },
    activity: {
      type: ActivityModel
    },
    invitation: {
      default: null,
      type: String
    },
    finished: {
      default: false,
      type: Boolean
    },
    failed: {
      default: false,
      type: Boolean
    },
    unstarted: {
      default: false,
      type: Boolean
    }
  },
  components: {
    ProgressBar
  },
  methods: {
    async acceptRequest() {
      let invitation = await this.$store.getters[
        "targetinvitation/targetInvitation"
      ](this.invitation);

      await this.$store.getters["targetinvitation/api"].Custom.Accept(
        this.invitation
      );
      await this.$store.getters["target/api"].Show(invitation.target_id);
    },
    rejectRequest() {
      this.$store.getters["targetinvitation/api"].Custom.Reject(
        this.invitation
      );
    },
    openTargetDetails() {
      if (this.invitation) {
        return this.goTo("/target-invitation/" + this.invitation);
      }
      this.goTo("/target/" + this.target.id);
    }
  },
  computed: {
    percentage() {
      return (100 * this.target.value) / this.target.target;
    },
    upcoming() {
      let days = 3;
      return this.checkDate(this.target.end, days);
    },
    endDate() {
      return this.moment(this.target.end);
    }
  },
  async created() {
    let ownId = this.$store.getters["auth/ownId"];
    if (this.invitation) {
      this.user = await this.$store.getters["users/api"].Show(
        this.target.user_id
      );
    }
    this.loaded();
  }
};
</script>
